import React, { FormEvent, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Btn, H3, H6, Image, P } from "../AbstractElements";
import { dynamicImage } from "../Utils";
import { Col, Form, FormGroup, Input, Label } from "reactstrap";
import {
  CreateAccount,
  DontHaveAccount,
  EmailAddress,
  FacebookLink,
  ForgotPassword,
  LinkedIn,
  Password,
  RememberPassword,
  SignIn,
  SignInAccount,
  SignInWith,
  TwitterLink,
} from "../Utils/Constants";
import FeatherIconCom from "../Utils/CommonComponents/CommonIcons/FeatherIconCom";
import { postData } from "../CommonElements/Functions/PostGetFun";
import { setItem } from "../Utils/StorageHelper";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../redux-toolkit/store";
import { API } from "../api/API";
import { getData } from "../CommonElements/Functions/PostGetFun";
import { setUserData } from "../redux-toolkit/reducers/UserDatareducer";
import { saveUserDataSeparately } from "../Utils/saveUserDB";
import Dexie, { Table } from "dexie";

export default function SignInForm() {
  const navigate = useNavigate();
  const [step, setStep] = useState(0);
  const [companyCode, setCompanyCode] = useState("");
  const [isPasswordVisible, setPasswordVisible] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    localStorage.clear();
    const envUrl = "https://sfa.nitiapp.com/";
    if (envUrl) {
      localStorage.setItem("serverUrl", envUrl);
    }
  }, []);

  const serverUrl = localStorage.getItem("serverUrl");
  console.log("serverUrl", serverUrl);
  const dispatch = useDispatch<AppDispatch>();
  const toggle = () => setPasswordVisible(!isPasswordVisible);

  const handleCompanyCodeSubmit = async (e: FormEvent) => {
    e.preventDefault();
    if (!companyCode) {
      toast.error("Please enter company code");
      return;
    }

    setLoading(true);
    try {
      const url = `https://sfa.nitiapp.com/api/system/getCompanyJsonUrl`;
      const { status, data } = await getData(url, {
        company_code: companyCode,
      });

      if (status === 200 && data.data?.data?.base_url) {
        const baseUrl = data.data.data.base_url;
        localStorage.setItem("serverUrl", baseUrl);
        setStep(1);
      } else {
        const url2 = `https://sfa.nitiapp.com/api/checkCompany`;
        const { status: status2, data: data2 } = await postData(url2, false, {
          company_code: companyCode,
        });
        if (status2 === 200 && data2.data?.AppBaseUrl) {
          const baseUrl = data2.data.AppBaseUrl;
          localStorage.setItem("serverUrl", baseUrl);
          setStep(1);
        } else {
          toast.error(data2.message || data.message || "Invalid company code");
        }
      }
    } catch (error) {
      toast.error("An error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e: FormEvent) => {
    toast.success("Login request sent!");
    e.preventDefault();
    await Dexie.delete("DynamicDB");
    localStorage.removeItem("schema_Employee");
    const url = `${serverUrl}${API.login}`;
    const { status, data } = await postData(url, false, {
      username: email,
      password: password,
    });

    console.log("Full API response:", data);

    if (status === 200 && data.data?.AppToken) {
      const token = data.data.AppToken;

      localStorage.setItem("isLoggedIn", "true");
      localStorage.setItem("appToken", token);

      // Normalize employee: API may return an array or a single object
      const rawEmployee = data.data?.employee;
      const employee = Array.isArray(rawEmployee)
        ? rawEmployee[0]
        : rawEmployee;

      // console.log("AppToken:", token);
      console.log("Login Data:", data.data);
      // console.log("Employee Data:", employee?.EmployeeId);
      // console.log("Position Data:", employee?.PositionId);

      if (employee?.EmployeeId)
        localStorage.setItem("empId", String(employee.EmployeeId));
      if (employee?.PositionId)
        localStorage.setItem("positionId", String(employee.PositionId));
      if (employee?.OrgUnitId)
        localStorage.setItem("orgUnitId", String(employee.OrgUnitId));
      if (employee?.EmployeeCode)
        localStorage.setItem("employeeCode", String(employee.EmployeeCode));
      toast.success(data.message || "Login Success...!");
      navigate(`/firstLoader`);
    } else {
      toast.error(data.message || "Invalid username or password");
    }
  };

  return (
    <div>
      <div>
        <Link className="logo" to={`/admin`}>
          <Image
            className="img-fluid for-light"
            src={dynamicImage(`logo/logo-1.png`)}
            alt="loginpage"
            style={{ width: "200px" }}
            body={true}
          />
        </Link>
      </div>
      <div className="login-main border shadow">
        {step === 0 ? (
          <Form className="theme-form" onSubmit={handleCompanyCodeSubmit}>
            <H3>{"Enter Access Code"}</H3>
            <P>{"Use the code sent by your company to access"}</P>
            <FormGroup>
              <Col>
                <Label>{"Company Code"}</Label>
              </Col>
              <Input
                type="text"
                placeholder="Enter company code"
                value={companyCode}
                onChange={(event) => setCompanyCode(event.target.value)}
              />
            </FormGroup>
            <div className="mb-0 form-group">
              <div className="text-end mt-3">
                <Btn
                  color="primary"
                  className="btn-block w-100"
                  disabled={loading}
                >
                  {loading ? "Verifying..." : "Submit"}
                </Btn>
              </div>
            </div>
          </Form>
        ) : (
          <Form className="theme-form" onSubmit={handleSubmit}>
            <H3>{SignInAccount}</H3>
            <P>{"Enter your email & password to login"}</P>
            <FormGroup>
              <Col>
                <Label>{EmailAddress}</Label>
              </Col>
              <Input
                type="email"
                placeholder="Enter your email"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
              />
            </FormGroup>
            <FormGroup>
              <Col>
                <Label>{Password}</Label>
              </Col>
              <div className="form-input position-relative">
                <Input
                  type={isPasswordVisible ? "text" : "password"}
                  placeholder="Enter your password"
                  value={password}
                  onChange={(event) => setPassword(event.target.value)}
                  name="login[password]"
                />
                <div className="show-hide" onClick={toggle}>
                  <span className={!isPasswordVisible ? "show" : ""}></span>
                </div>
              </div>
            </FormGroup>
            <div className="mb-0 form-group">
              <div className="text-end mt-3">
                <Btn color="primary" className="btn-block w-100">
                  {SignIn}
                </Btn>
              </div>
            </div>
          </Form>
        )}
      </div>
    </div>
  );
}
